// React i hooks
import { NavLink } from "react-router-dom";
import { memo } from "react";

// Helpers
import { classNames, transformRoute } from "helpers";

// Moduli specifični za projekt
import { Routes as UserRoutes } from "ui/modules/users/navigation";

// Tipovi i konstante
import { TabMenuProps } from "./types";


const TabMenu: React.FC<TabMenuProps> = (props) => {
  const { userId } = props;

  return (
    <>
      <div className="flex border-b border-slate-200 bg-white">
        <NavLink
          to={transformRoute(UserRoutes.UserDetailPageRouter, {
            id: userId,
          })}
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600",
              "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
          Detalji
        </NavLink>
        <NavLink
          to={transformRoute(UserRoutes.UserPermissionSearchPageRouter, {
            id: userId,
          })}
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600",
              "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
          Korisnička prava
        </NavLink>
      </div>
    </>
  );
};

export default memo(TabMenu);
